import React from 'react';
import { Row, Col } from 'react-bootstrap';

export default function EmergencyResourcesUTSCStudent() {
  return (
    <div>
      <Row>
        <Col xs={10} xsOffset={1}>
          <h2 className="text-center no-bold txt-dkblue">
            Urgent & Emergency Resources
          </h2>
          <p>
            In urgent situations where there’s concerns about anyone's safety, a more
            immediate connection or referral is required even when the person you are
            concerned about is unwilling to access these resources themselves. As soon
            as you can, inform someone who is in a position to act. For situations that
            include harm to self or others, contact the Emergency Situations resources.
            For general, time-sensitive resources, contact one of the Urgent Situations
            resources.
          </p>
        </Col>
      </Row>
      <Row>
        <Col xs={10} xsOffset={1}>
          <Col xs={12} sm={6}>
            <div className="situation-grid-container">
              <div className="grid-item-heading">Emergency Situations</div>
              <div className="grid-item">
                <div className="grid-item-info">
                  <strong>Emergency Services</strong>
                  <br />
                  <a href="tel:911">911</a>
                  <br />
                  24/7
                  <br />
                  Various, Ontario
                  <br />
                  <a href="https://crtc.gc.ca/eng/phone/911" rel="noopener noreferrer" target="_blank">
                    crtc.gc.ca/eng/phone/911
                  </a>
                </div>
                For life-threatening emergencies or incidents occurring in the
                moment where you need police, fire, or ambulance. If responding
                on campus also contact Campus Police to ensure prompt service.
              </div>
              <div className="grid-item custom-grid-height">
                <div className="grid-item-info">
                  <strong>Campus Police</strong>
                  <br />
                  <a href="tel:416 978 2222">416 978 2222</a>
                  <br />
                  24/7
                  <br />
                  Science Wing, Room SW 304, 1265 Military Trail
                  <br />
                  <a href="https://utsc.utoronto.ca/police" rel="noopener noreferrer" target="_blank">
                    utsc.utoronto.ca/police
                  </a>
                </div>
                Provides 24/7 service and protection to the UTSC community.
                Officers patrol the campus on foot, on bicycles and in vehicles.
                If you are concerned about an immediate threat to your safety or
                property, or that of others, call 911 or Campus Community Police
                at (416) 978-2222, or use one of the emergency Code Blue
                telephones located on campus.
              </div>
            </div>
          </Col>
          <Col xs={12} sm={6}>
            <div className="situation-grid-container">
              <div className="grid-item-heading">Urgent Situations</div>

              <div className="grid-item">
                <div className="grid-item-info">
                  <strong>Health & Wellness Centre</strong>
                  <br />
                  <a href="tel:416 287 7065">416-287-7065</a>
                  <br />
                  Business Hours
                  <br />
                  SL-270, 1265 Military Trail
                  <br />
                  <a href="https://www.utsc.utoronto.ca/hwc" rel="noopener noreferrer" target="_blank">
                    www.utsc.utoronto.ca/hwc
                  </a>
                </div>
                Offers convenient and confidential health care, counselling and
                health promotion services for all registered students at UTSC.
              </div>
              <div className="grid-item custom-grid-height">
                <div className="grid-item-info">
                  <strong>Immediate On-Campus Supervisor</strong>
                  <br />
                  <span>Name: ___________________</span>
                  <br />
                  <span>Contact: __________________</span>
                </div>
                <span>
                  Whether a referral is made or not - if you are supporting
                  someone as a result of your role as a student leader, staff or
                  faculty member, you should inform your supervisor and/ or the
                  appropriate contact within your unit.
                </span>
              </div>
            </div>
          </Col>
        </Col>
      </Row>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/containers/IARReference/EmergencyResources/EmergencyResourcesUTSCStudent.js